

















































































































































































































































import Component from 'vue-class-component'
import { Base } from "@/base";
import { validData } from '@/constants/sidebarData';
import { regular } from '@/constants/commonContent';
import * as Web3Utils from 'web3-utils';
import InputsComponent from '@/components/InputsComponent.vue';

@Component({
  name: 'InitCompanyComponent',
  components: {
    InputsComponent
  }
})
export default class InitCompanyComponent extends Base {
  validData = validData;
  default = {
    tokenName: 'Korporatio',
    tokenSymbol: 'KORP',
    tokenTotalsupply: 100000,
    votingPercents: 75,
    lockedTokens: undefined
  };
  address = null;
  ownerName = '';
  ownerEmail = '';
  tokenName: any = this.default.tokenName;
  tokenSymbol: any = this.default.tokenSymbol;
  tokenTotalsupply: any = this.default.tokenTotalsupply;
  votingPercents: any = this.default.votingPercents;
  infoText = '';

  private lockedTokens: any;
  // Computed
  get isPending() {
    return this.getPendings.initialization.update
  }
  mounted() {
    this.resetParameters();
  }
  // Methods
  isAddress(addr) {
    if (addr && addr.slice(0, 2) !== '0x') {
      return false;
    }
    //it's needed for color change of form's input
    //null - default(gray), false - error(red), true - okay(green)
    return !addr ? null : Web3Utils.isAddress(addr);
  }
  isEmail(email) {
    return regular.validate.email.test(email);
  }
  isCorrectNewOwner() {
    return (
            !!this.ownerName &&
            !!this.ownerEmail &&
            this.isEmail(this.ownerEmail) &&
            this.ownerName.length >= this.validData.member.name.min &&
            this.ownerName.length <= this.validData.member.name.max &&
            this.ownerEmail.length >= this.validData.member.email.min &&
            this.ownerEmail.length <= this.validData.member.email.max
    );
  }
  isCorrectInitiateParameters() {
    return (
            !!this.tokenName &&
            !!this.tokenSymbol &&
            !!this.tokenTotalsupply &&
            !!this.votingPercents &&
            this.tokenName.length >= this.validData.token.name.min &&
            this.tokenName.length <= this.validData.token.name.max &&
            this.tokenSymbol.length >= this.validData.token.symbol.min &&
            this.tokenSymbol.length <= this.validData.token.symbol.max &&
            this.tokenTotalsupply >= this.validData.token.amount.min &&
            this.tokenTotalsupply <= this.validData.token.amount.max &&
            this.votingPercents >= this.validData.voting.percent.min &&
            this.votingPercents <= this.validData.voting.percent.max
    );
  }
  changeOwner(address) {
    this.infoText =
            "You've changed the owner. Now please sign your request (send the transaction).";
    this.initializationPending(true);
    this.changeOwnerDapp(address).then((err) => {
      this.initializationPending(true);
      if (err) return;
      this.resetOwners();
      this.$router.push('/');
    }).catch((err) => {
      console.log(err);
      this.initializationPending(true);
      this.$router.push('/');
    });
  }
  initFirstOwner(ownerName, ownerEmail) {
    this.infoText =
            "You've initiated the owner. Now please sign your request (send the transaction).";
    this.initializationPending(true);
    this.addFirstOwnerDapp({
      ownerName,
      ownerEmail: ownerEmail.toLowerCase()
    }).then(() => {
      this.initializationPending(false);
      this.$router.push('/');
      window.location.reload();
    }).catch((err) => {
      console.log(err);
      this.initializationPending(false);
      this.$router.push('/');
    });
  }
  // First step
  initiateParameters() {
    this.infoText =
            "You've initiated parameters. Now please sign your request (send the transaction).";
    this.initializationPending(true);

    this.initiateParametersDapp({
      tokenName: this.tokenName,
      tokenSymbol: this.tokenSymbol,
      tokenTotalsupply: parseInt(this.tokenTotalsupply),
      votingPercents: parseInt(this.votingPercents)
    }).then(() => {
      this.addCompanyInfoDapp({name: this.tokenName, about: ''}).then(() => {
        this.initializationPending(false);
        this.$router.push('/');
        window.location.reload();
        setTimeout(() => {
          this.isInitiatedTokenDapp();
          this.$router.push('/');
        }, 10000);
      })
    }).catch((err) => {
      console.log(err);
      this.initializationPending(false);
      this.$router.push('/');
    });
  }
  resetChangeOwner() {
    this.address = null;
  }
  resetInitFirstOwner() {
    this.ownerName = '';
    this.ownerEmail = '';
  }
  resetParameters() {
    this.tokenName = this.default.tokenName;
    this.tokenSymbol = this.default.tokenSymbol;
    this.tokenTotalsupply = this.default.tokenTotalsupply;
    this.lockedTokens = this.default.lockedTokens;
    this.votingPercents = this.default.votingPercents;
  }
};
